import { Link } from '@eleveo/components-react';
import React from 'react';

import { FooterLinkType } from '../manageAccount/ManageAccountDropdown';

export interface AppSwitcherProps {
  links: FooterLinkType[];
}

export const AppSwitcher: React.FC<AppSwitcherProps> = ({ links }) => {
  return (
    <div className="app-switcher">
      <ul className="app-switcher__list">
        {links.map(({ icon, text, to, testId }) => (
          <li key={to} className="app-switcher__link">
            <Link href={to} className="flex items-center justify-start" testId={testId}>
              {icon}
              <p> {text} </p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
